<template>
    <ul class="submenu-sections">
        <router-link tag="li" :to="{name:'ClockDetails', params:$route.params}">
            <a>
                <h4><span class="text">Boxes</span></h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'ClockConstraints', params:$route.params}">
            <a>
                <h4><span class="text">Constraints</span></h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'ClockStats', params:$route.params}">
            <a>
                <h4><span class="text">Statistics</span></h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'ClockBranding', params:$route.params}">
            <a>
                <h4><span class="text">Branding</span></h4>
            </a>
        </router-link>

    </ul>
</template>

<script>
    import router from '@/router'
    export default {
        name: "ClockMenu",
        router,
        watch: {
            '$route' () {
                this.$forceUpdate();
            }
        }
    }
</script>

<style scoped>
</style>
